import { Badge, OverlayTrigger, Tooltip, NavItem } from 'react-bootstrap'
import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

const LoadedViaTokenIndicator = () => {
  const { token, family_token } = useSelector(
    (state: RootState) => state.participant.data
  )

  return (
    <NavItem className="mr-2">
        <Badge pill variant="info">
          { token ? (
            <OverlayTrigger
              overlay={
                <Tooltip id="tooltip-sibling-payment">
                  Daten vom Teilnehmer wurden geladen. Neue Anmeldungen können hinzugefügt werden.
                </Tooltip>
              }
            >
              <span>Hinzufügen von Anmeldungen</span>
            </OverlayTrigger>
            ) : family_token ? (
            <OverlayTrigger
              overlay={
                <Tooltip id="tooltip-sibling-payment">
                  Daten vom Familienmitglied wurden automatisch
                  vorausgefüllt.
                </Tooltip>
              }
            >
              <span>Anmeldung Familienmitglied</span>
            </OverlayTrigger>
            ) : <></>
          }
      </Badge>
    </NavItem>
  )
}

export default LoadedViaTokenIndicator